var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "categories-grid"
  }, _vm._l(_vm.list, function (category) {
    var _category$thumbnail;

    return _c('div', {
      key: category.id,
      staticClass: "categories-grid__el"
    }, [_c('nuxt-link', {
      staticClass: "categories-grid__el-photo",
      attrs: {
        "to": category.path
      }
    }, [_c('LazyImg', {
      staticClass: "categories-grid__el-img",
      attrs: {
        "img": (_category$thumbnail = category.thumbnail) === null || _category$thumbnail === void 0 ? void 0 : _category$thumbnail.x2,
        "alt": category.name
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "categories-grid__el-title"
    }, [_c('nuxt-link', {
      staticClass: "link link_wu",
      attrs: {
        "to": category.path,
        "title": category.name
      }
    }, [_vm._v("\n        " + _vm._s(category.name) + "\n      ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "categories-grid__list"
    }, [_vm._l(category.children, function (category2, idx) {
      return [idx < 4 ? _c('div', {
        key: category2.id,
        staticClass: "mb-6 lh-19"
      }, [_c('nuxt-link', {
        staticClass: "link link_wu",
        attrs: {
          "to": category2.path,
          "title": category2.name
        }
      }, [_vm._v("\n            " + _vm._s(category2.name) + "\n          ")])], 1) : _vm._e()];
    })], 2), _vm._v(" "), category.children && category.children.length > 5 ? _c('nuxt-link', {
      staticClass: "categories-grid__el-link link link_blue link_wu",
      attrs: {
        "to": category.path,
        "title": "Все категории"
      }
    }, [_vm._v("\n      Все категории\n    ")]) : _vm._e()], 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }